import { store } from '../../index';
import * as requestType from '../../ressources/glossaires/glossaire_requetes';
import {
  askForPasswordReset,
  authentication,
  checkConnexion,
  logout,
  requestPasswordChange,
  resetPassword,
  validateCodeVerification,
} from '../api';
import { affichageRetourErreurs } from '../utils/utils';
import * as actionTypes from './actionTypes';
import * as actions from './index';

export const intervalDeTempsDemandeInfoConnexionApresConnexion = 14400000;

const requestBack = async (dispatch, requestId, payload) => {
  dispatch(actions.debutAttente(requestId));
  try {
    let response;
    switch (requestId) {
      case requestType.connexion:
        response = await authentication(payload);
        if (response.data.state && response.data.user_id > 0) {
          localStorage.setItem(
            'auth',
            JSON.stringify({
              login_name: payload.login_name,
              login_password: await crypto.subtle
                .digest(
                  'SHA-1',
                  new TextEncoder('utf-8').encode(payload.login_password)
                )
                .then((hash) => {
                  return hash;
                }),
            })
          );
          dispatch(enregistrerUtilisateur(response.data));
          dispatch(actions.reqRecupererAccueilSummary());
          setTimeout(
            () => actions.demandeInformationDeConnexion(dispatch),
            intervalDeTempsDemandeInfoConnexionApresConnexion
          );
          return;
        }
        break;

      case requestType.deconnexion:
        response = await logout();
        if (response.data.state) {
          dispatch(actions.deconnexion());
          window.location.href = '/';
          return;
        }
        break;

      case requestType.changer_son_mot_de_passe:
        response = await requestPasswordChange(payload);
        if (response.data.state) {
          dispatch(validationChangementMotDePasse());
          return;
        }
        break;

      case requestType.demande_de_reinitialisation_du_mot_de_passe:
        response = await askForPasswordReset(payload);
        if (response.data.state) {
          dispatch(demandeReinitialisationMDPReussie());
          return;
        }
        break;

      case requestType.validation_du_code_de_verification:
        response = await validateCodeVerification(payload);
        if (response.data.state) {
          dispatch(validationCodeVerificationReussie());
          return;
        }
        break;

      case requestType.reinitialisation_du_mot_de_passe:
        response = await resetPassword(payload);
        if (response.data.state) {
          dispatch(reinitialisationMDPReussie());
          return;
        }
        break;
      default:
        break;
    }
    affichageRetourErreurs(
      dispatch,
      'danger',
      `Erreur dans la requête ${requestId}`,
      response
    );
  } catch (err) {
    console.error('Erreur de connexion:', err);
  } finally {
    dispatch(actions.finAttente(requestId));
  }
};

//[non authentifié] fonction permettant de se connecter
export const authentification = (login_name, login_password) => {
  return (dispatch) => {
    requestBack(dispatch, requestType.connexion, {
      login_name,
      login_password,
    });
  };
};
//[déjà authentifié] Groupe de fonction permettant de gérer les statuts d'authentification
export const demandeInformationDeConnexion = (dispatch) => {
  /**
   * Fonction récursive pour la requête d'information de connexion
   * @return une fonction dispatch - une fonction pour réaliser des action asynchrone, dispatch aussi des alertes pour agir sur le réducteur alerte.js
   *      tant que l'utilisateur est connécté sur la base de donné fait un appel récursive
   */
  const state = store.getState();
  dispatch(actions.debutAttente(requestType.information_de_connexion));
  checkConnexion()
    .then((res) => {
      if (res?.data.state) {
        setTimeout(
          () => actions.demandeInformationDeConnexion(dispatch),
          intervalDeTempsDemandeInfoConnexionApresConnexion
        );
        if (state.authentifie.user_id === null) {
          //cas d'une nouvelle page ou du rafraichissement de la page
          //récupération des informations de l'utilisateur connecté
          dispatch(actions.reqRecupererUnUtilisateur(res.data.user_id));
        } else if (res.data.user_id !== state.authentifie.user_id) {
          //cas où user_id de la session sur le serveur ne correspond pas à user_id local
          dispatch(actions.deconnexionAutomatique()); //déconnexion partielle si l'utilisateur n'est pas le même que celui connecté sur le serveur
        }
      } else {
        dispatch(actions.deconnexionAutomatique()); //déconnexion partielle si l'utilisateur n'est pas connecté sur le serveur
        affichageRetourErreurs(dispatch, 'danger', res);
      }
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() =>
      dispatch(actions.finAttente(requestType.information_de_connexion))
    );
};

export const seDeconnecter = () => {
  // return {type:actionTypes.RE_CONNEXION, idConnexion:idConnexion, motDePasse:motDePasse};
  return (dispatch) => {
    requestBack(dispatch, requestType.deconnexion);
  };
};

//[déjà authentifié] Groupe de fonction permettant de gérer les informations de l'utilisateur connecté
export const reqChangerMDP = (
  login_password,
  new_password,
  new_pass_confirm
) => {
  return (dispatch) => {
    requestBack(dispatch, requestType.changer_son_mot_de_passe, {
      login_password,
      new_password,
      new_pass_confirm,
    });
  };
};

//[non authentifié] Groupe de fonction permettant de réinitialiser un mot de passe
export const demandeReinitialisationMDP = (email) => {
  return (dispatch) => {
    requestBack(
      dispatch,
      requestType.demande_de_reinitialisation_du_mot_de_passe,
      {
        email,
      }
    );
  };
};

export const validationCodeVerification = (codeVerification) => {
  /**
   * envoie la requête de vérification du code de validation
   */
  return (dispatch) => {
    requestBack(dispatch, requestType.validation_du_code_de_verification, {
      codeVerification,
    });
  };
};

export const reinitialisationMDP = (
  verification_code,
  new_password,
  new_password_confirm
) => {
  return (dispatch) => {
    requestBack(dispatch, requestType.reinitialisation_du_mot_de_passe, {
      verification_code,
      new_password,
      new_password_confirm,
    });
  };
};

//[déjà authentifié] Groupe de fonction permettant de gérer l'interface de l'utilisateur (commutateur interface admin/client, filtre par projet_id)
export const commutateurInterfaceClient = () => {
  return { type: actionTypes.COMMUTER_INTERFACE_CLIENT };
};
export const commutateurInterfaceAdmin = () => {
  return { type: actionTypes.COMMUTER_INTERFACE_ADMIN };
};
export const gererFiltreParProjet = (filtre_projects_list_id) => {
  return {
    type: actionTypes.GERER_FILTRE_PAR_PROJET,
    filtre_projects_list_id: filtre_projects_list_id,
  };
};
export const deconnexionAutomatique = () => {
  return { type: actionTypes.DECONNEXION_AUTOMATIQUE };
};
export const deconnexion = () => {
  return { type: actionTypes.DECONNEXION };
};
const demandeReinitialisationMDPReussie = () => {
  return { type: actionTypes.DEMANDE_DE_REINITIALISATION_MDP_REUSSIE };
};
const validationCodeVerificationReussie = () => {
  return { type: actionTypes.VALIDATION_CODE_VERIFICATION_REUSSIE };
};
const reinitialisationMDPReussie = () => {
  return { type: actionTypes.REINITIALISATION_MDP_REUSSIE };
};
const validationChangementMotDePasse = () => {
  return { type: actionTypes.VALIDATION_CHANGEMENT_MOT_DE_PASSE };
};
export const enregistrerUtilisateur = (data) => {
  return {
    type: actionTypes.DEBUT_AUTH,
    ...data,
    // user_id: data.user_id,
    // lastname: data.lastname,
    // name: data.name,
    // privileges_list: data.privileges_list,
    // projects_list: data.projects_list,
    // favorite_projects_list_id: data.favorite_projects_list_id,
    // email:data.email,
    // phone_index:data.phone_index,
    // phone_number:data.phone_number,
    // company_name:data.company_name,
    // profil_image:data.profil_image
  };
};
